import { useContext } from "react"
import InternalFormContext from "../contexts/InternalFormContext";

const useInternalFormContext = () => {
    return useContext(InternalFormContext);
}

export default useInternalFormContext;